export default __webpack_public_path__ + "static/media/ay-logo.f8818ebc.svg";